{
  "projectId": "marine-welder-5nd4h",
  "appId": "1:432553439887:web:0eea3cb2e95be127c076fa",
  "apiKey": "AIzaSyA1i9zrsALx3Xn2F3Iz8tYMwuLTaE1xnJE",
  "authDomain": "marine-welder-5nd4h.firebaseapp.com",
  "storageBucket": "marine-welder-5nd4h.firebasestorage.app",
  "messagingSenderId": "432553439887",
  "measurementId": "",
  "oAuthClientId": "432553439887-fvc5i8rvop8g4kpaegn5i7j0v4fikg9j.apps.googleusercontent.com",
  "recaptchaSiteKey": ""
}